import { render } from "./EnergySource.vue?vue&type=template&id=05b20780&scoped=true"
import script from "./EnergySource.vue?vue&type=script&lang=js"
export * from "./EnergySource.vue?vue&type=script&lang=js"

import "./EnergySource.vue?vue&type=style&index=0&id=05b20780&scoped=true&lang=css"

import exportComponent from "/usr/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05b20780"]])

export default __exports__